<mat-form-field class="example-full-width" appearance="standard">
    <mat-label>Adresse</mat-label>
    <input type="text" matInput ngx-google-places-autocomplete [options]='options' [disabled]="!isReadOnlyAdresse" name="adresseComplete" [ngModel]="adresseComplete" #filterName #placesRef="ngx-places" (onAddressChange)="handleAddressChange($event)" autocomplete="chrome-off"
        id="" placeholder="5 rue picot, Toulon...">
    <mat-icon [ngStyle]="{color: iconColor ? iconColor : 'black'}" matSuffix>room</mat-icon>
</mat-form-field>
